import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useBrandSettings = () => {
  return useQuery({
    queryKey: ['brand-settings'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('brand_settings')
        .select('*')
        .limit(1)
        .maybeSingle();
      
      if (error) throw error;
      
      // Return default values if no settings exist
      return data || {
        store_name: 'المتجر',
        logo_url: '',
        favicon_url: '',
        primary_color: '#10b981',
        secondary_color: '#059669',
        accent_color: '#34d399',
        header_bg_color: '#10b981',
        header_text_color: '#ffffff',
        button_bg_color: '#10b981',
        button_text_color: '#ffffff',
        floating_cta_bg_color: '#ec4899',
        floating_cta_text_color: '#ffffff'
      };
    },
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
};
